module.exports = __webpack_public_path__ + "img/ambassade.281d71ec.png";